import React from 'react'

import "./fadeBox.css"
import { Box } from '@mui/material'

export const FadBox = (props) =>
    <div className="fade-image-container">
        {props.text
            ? <Box position="relative">
                <img
                    srcSet={props.src}
                    src={props.src}
                    alt={props.alt}
                    className="fade-image gray"
                    loading="eager"
                />
                <div className="middle">
                    <div className="fade-text">{props.text}</div>
                </div>
                <Box
                    position="absolute"
                    zIndex={2}
                    width={'100%'}
                    height={'100%'}
                    top={0}
                    left={0} />
            </Box>
            : <Box position="relative">
                <img
                    srcSet={props.src}
                    src={props.src}
                    alt={props.alt}
                    className="fade-image"
                    loading="eager"
                />
                <Box
                    position="absolute"
                    zIndex={2}
                    width={'100%'}
                    height={'100%'}
                    top={0}
                    left={0} />
            </Box>
        }
    </div>
